import GroupLayout from "./GroupLayout";

const BillabongLayout = () => (
  <GroupLayout
    brandName="Billabong"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/billabong-logo.png"
    groupId="10000000055"
    headline="Billabong High International Schools "
  />
);

export default BillabongLayout;
